<template>
	<div>
        <div v-if="news_info.length > 0">
            <vs-input v-if="page == 'news_show'" :placeholder="$t('Pesquisa')" v-model="searchQuery" icon-pack="feather" icon="icon-search" size="large" class="w-full mt-6 h45" icon-no-border />
            <vs-collapse accordion type="margin" class="p-0">
        		<vs-collapse-item class="faq-bg rounded-lg back-g" v-for="(info, index) in filteredNews" :key="index">
                    <div slot="header"><h5>{{info.translation[0].titulo}}</h5><span class="text-sm">{{info.created_date}}</span></div>
                    <img :src="info.translation[0].image_path" class="responsive rounded">

                    <QuillPresentInfo v-bind:info="info.translation[0].description" v-bind:cssClass="'mt10mb20'">
                    </QuillPresentInfo>

                    <div class="w-full mb10">
                        <feather-icon icon="ThumbsUpIcon" class="mr10 iconLike" @click="darLikeOuDislike('like', index)" v-if="info.vote.length == 0"></feather-icon>
                        <feather-icon icon="ThumbsUpIcon" class="mr10 iconLike" @click="darLikeOuDislike('like', index)" v-else :svgClasses="{'fill-current stroke-current': info.vote[0].news_vote_type_id == 1}"></feather-icon>
                        <span class="font-bold nrLikeDislike mr15">{{info.likes}}</span>
                        <feather-icon icon="ThumbsDownIcon" class="mr10 iconDislike" @click="darLikeOuDislike('dislike', index)" v-if="info.vote.length == 0"></feather-icon>
                        <feather-icon icon="ThumbsDownIcon" class="mr10 iconDislike" @click="darLikeOuDislike('dislike', index)" v-else :svgClasses="{'fill-current stroke-current': info.vote[0].news_vote_type_id == 2}"></feather-icon>
                        <span class="font-bold nrLikeDislike">{{info.dislikes}}</span>
                    </div>
                    <vs-row vs-type="flex" vs-justify="center">
                        <router-link :to="{name: 'news-show-single', params: { id: info.id }}" tag="vs-button" class="centerButton">
                            <vs-button  color="primary" type="filled" icon-pack="feather" icon="icon-plus" class="styleButton">
                                {{$t('Ver_mais')}}
                            </vs-button>
                        </router-link>
                    </vs-row>
                </vs-collapse-item>
            </vs-collapse>
        </div>
        <vx-card v-else>
            <div class="text-center">
                {{ $t('nao_foram_encontradas_noticias') }}
            </div>
        </vx-card>
	</div>
</template>

<script>

//load configurations on theme
import themeConfig from '@/../themeConfig.js';
import QuillPresentInfo from '@/views/components/QuillPresentInfo.vue'

export default {
    props: ['news_info', 'page'],
    data() {
        return {
            searchQuery: ''
        }
    },
    methods: {
        darLikeOuDislike(type, index){
            this.$vs.loading();

            var news_id = this.news_info[index].id;
            var type_id = type == 'like' ? 1 : 2;
            var vote_id = null

            if(this.news_info[index].vote.length > 0){
                vote_id = this.news_info[index].vote[0].news_vote_id;
            }

            this.$api.post( '/myvilagale/news/saveVote?token=' + this.$user.usertoken,
            {
                news_id: news_id,
                type_id: type_id,
                user_id: this.$user.id,
                vote_id: vote_id
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.$user.usertoken
                }
            })
            .then((res) => {
                this.$vs.loading.close();
                this.news_info[index].vote = res.data.vote;
                this.news_info[index].likes = res.data.likes;
                this.news_info[index].dislikes = res.data.dislikes;
            })
            .catch((err) => {
                this.notify(err.response.data.message, 'red', 10);
                this.$vs.loading.close();
            });

        }
    },
    computed: {
        filteredNews () {
            if(this.searchQuery === ''){
                return this.news_info;
            }
            let that = this;
            return this.news_info.filter(function(news) {
                return news.translation[0].titulo.toLowerCase().trim().indexOf(that.searchQuery.toLowerCase().trim()) > -1 ||
                news.translation[0].description.toLowerCase().trim().indexOf(that.searchQuery.toLowerCase().trim()) > -1
            })
        }
    },
    components: {
        QuillPresentInfo,
    },
}
</script>

<style>
    .vs-inputx.vs-input--input.large.hasIcon{
        padding-left: 45px;
    }
    .input-span-placeholder.vs-input--placeholder.large{
        padding-left: 45px !important;
        padding-top: 17px;
    }
    .centerButton{
        display: flex;
        align-items: center;
    }
    .styleButton{
        height: 15px;
    }
    .mr10{
        margin-right: 10px;
    }
    .mr15{
        margin-right: 15px;
    }
    .mr40{
        margin-right: 40px;
    }
    .mb10{
        margin-bottom: 10px;
    }
    .iconLike{
        color: #4EE44E;
    }
    .iconDislike{
        color: #ff3232;
    }
    .nrLikeDislike{
        position: relative;
        bottom: 5px;
    }
    .descricao{
        margin-bottom: 5px;
        overflow: hidden;
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .back-g{
        background: white;   
    }
    .pre{
        white-space: pre-wrap;
    }
</style>
